<template>
    <div>

        <div v-if="isEditor && isVisible" :style="style" style="width: 350px;"
             id="colorPickerElement" @mousedown="stopMousedownPropagation">

            <p style="margin-bottom: 15px">Order No.: {{truckOrder.truckOrderNumber}}</p>

            <Form>
                <FormItem prop="truckName" label="Truck">
                    <Select v-model="truckName" filterable>
                        <Option v-for="truck in truckArr" :value="truck.platNo"
                                :label="truck.platNo" :key="truck.id">
                            <div class="ivu-select-item-div"
                                 @click="truckId=truck.id">{{truck.platNo}} </div>
                        </Option>
                    </Select>
                </FormItem>
                <div style="float: right">
                    <Button @click="updateTruckOnTruckOrder(truckOrder.id)" :disabled="!truckName" :loading="loader1">
                        <span v-if="!loader1">Save</span>
                        <span v-else>Loading...</span>
                    </Button>
                    <Button style="margin-left: 10px" @click="close()">Cancel</Button>
                </div>
            </Form>
        </div>

        <div v-if="isRenderer" style="text-align: center">
                {{value}}
        </div>

    </div>
</template>

<script>
    import {BaseEditorComponent} from '@handsontable/vue'
    import {GET_TRUCKS_BY_TRANSPORTER_ID} from "../../graphql/queries/vehicle"
    import {Constants} from "../../Constants/Constant"
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders"

    export default {
        name: "TruckPopup",
        extends: BaseEditorComponent,
        apollo: {
            truckArr: {
                query: GET_TRUCKS_BY_TRANSPORTER_ID,
                fetchPolicy: 'network-only',
                skip () {return !this.transporterId},
                variables() {
                    return {
                        transporterId: this.transporterId
                    }
                },
            },
        },
        data:function () {
            return{
                Constants: Constants,
                truckOrder: null,
                hotInstance: null,
                TD: null,
                row: null,
                col: null,
                prop: null,
                originalValue: null,
                value: '',
                cellProperties: null,
                isVisible: false,
                isEditor: null,
                isRenderer: null,
                editorElement: null,
                style: {
                    position: "absolute",
                    padding: "15px",
                    background: "#fff",
                    zIndex: 999,
                    border: "1px solid #000",
                    left: "0px",
                    top: "0px"
                },
                loader1: false,
                truckId: '',
                truckName: '',
                truckArr: [],
                transporterId: null
            }
        },
        methods:{
            stopMousedownPropagation: function(e) {
                e.stopPropagation();
            },
            prepare: function(row, col, prop, td, originalValue, cellProperties) {
                BaseEditorComponent.options.methods.prepare.call(this, row, col, prop, td, originalValue, cellProperties);
                const tdPosition = td.getBoundingClientRect();
                this.style.left = tdPosition.left + window.pageXOffset + 'px';
                // this.style.right = (window.innerWidth - tdPosition.right) + 'px';
                this.style.top = tdPosition.top + window.pageYOffset + 'px';
            },
            open: function() {
                let screen = this.$parent.$parent.$parent.screen
                let truckOrdersVariable = screen + '_truckOrders'
                let pRow = this.hotInstance.toPhysicalRow(this.row)                         //When accessing original array
                this.truckOrder = this.$parent.$parent.$parent[truckOrdersVariable][pRow]

                this.transporterId = this.truckOrder.Transporter.id
                this.truckName = this.value
                this.truckId = this.truckOrder.truck.id

                this.isVisible = true
            },
            focus: function() {
                this.isVisible = true;
            },
            close: function() {
                this.transporterId = null
                this.isVisible = false;
            },
            setValue: function(value) {
                this.value = value;
            },
            getValue: function() {
                return this.value;
            },
            updateTruckOnTruckOrder(truckOrderId){
                let obj = { truckId: this.truckId}
                this.updateRecord(truckOrderId, obj, 'truckOrders', 'loader1')
            },
            async updateRecord(id, obj, table, loaderStr){
                this[loaderStr] = true
                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: { id: id, obj: obj}
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!')
                    this[loaderStr] = false
                    this.close()
                    this.finishEditing()
                }
            },
        },
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }
    .green-text{
        color: green;
    }
    .red-text{
        color: red;
    }
</style>
